module.exports = __webpack_public_path__ + "img/eye-closed.a0fa2826.svg";